import request from "@/utils/request";

export function articleList(params) {
  return request({
    url: "/h5/sys/article",
    method: "get",
    params: params
  });
}

export function articleInfo(params) {
  return request({
    url: "/h5/sys/article/info",
    method: "get",
    params: params
  });
}

export function categoryList(params) {
  return request({
    url: "/h5/category",
    method: "get",
    params: params
  });
}





// WEBPACK FOOTER //
// ./src/api/sys_article.js